var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hover-steps-content"},[_c('div',{staticClass:"popover-steps-arrow"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'YYYY-MM-DD hh:mm A')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29794244","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewStepsDates.vue
// module id = 1739
// module chunks = 0